export default "__VITE_ASSET__YCGtArKB$SoHAcRX_5Kryg__";